module.exports = __webpack_public_path__ + "static/media/anesha-selector.e48334f7.png";